import { Form } from 'antd';
import type { ISelectOption } from 'types/select-option';
import { CargoFormSelect } from 'components/common/cargo-form-select';
import type { ISelectCargoFormProps } from './types';

export const SelectCargoForm = (props: ISelectCargoFormProps) => {
  const { form, formId, onFinish } = props;

  const handleChange = (option: ISelectOption<number>) => {
    form.setFieldsValue({ cargo: option });
  };

  return (
    <Form form={form} id={formId} name='cargo-add-to-trip' layout='vertical' onFinish={onFinish}>
      <CargoFormSelect
        name='cargo'
        placeholder='Select Cargo'
        rules={[{ required: true, message: 'Please select cargo' }]}
        handleChange={handleChange}
      />
    </Form>
  );
};
